export default "__VITE_ASSET__5ae5259d__"